"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stripPropertiesWithValue = _interopRequireDefault(require("./strip-properties-with-value"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stripUndefined(object) {
  return (0, _stripPropertiesWithValue["default"])(object, undefined);
}

var _default = stripUndefined;
exports["default"] = _default;